export default {
	products:[],
	branchsWare:[],

}


// WEBPACK FOOTER //
// ./src/modules/listproducts/state.js